import React from 'react'
import {Spin,message  } from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PropTypes from 'prop-types';
import Lang from "@components/Lang/Lang";
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import { toFixedWithCommas} from "@utils/number-util";
import FormFormat from '@/components/FormFormat/FormFormat';
import LogisticsAction from "../Logistics.action";
import {isEmpty} from "@utils/utils";
import ContactList from "../../component/contactList"
import "./index.less"
/**
 * 编辑物流公司弹窗
 * @author FJJ
 * @version 1.0
 *
 * @copyright 2021-2023, all rights reserved. Essa.cn
 * */
export default class Index extends React.Component {
    static defaultProps = {
        id:"", // 数据源
        children:""
    }
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading:false,
            // 详情
            detail:{}
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 赋值
    change(field,iType){
        let obj = this.state;
        obj[field] = iType;
        this.setState(obj)
    }
    // 打开
    open(flag=false){
        const { id } = this.props;
        if(flag&&!isEmpty(id)){
            this.getDetail(id)
        }else {
            this.setState({
                isModalVisible: flag
            })
        }
    }
    //初始化
    getDetail(id){
        this.loading(true);
        LogisticsAction.getDetail({
            id: id
        }).then(res=>{
            this.loading(false);
            const resData = res.data;
            const { success, valid,model} = resData;
            if (success &&valid) {
                // 成功
                this.setState({
                    isModalVisible: true,
                    detail: model||{}
                })
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        })

    }
    // 提交
    async submit(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success&&this.onRefContactListChild){
            let data = res.data;
            // 处理 cityCodeList 接口只有code值
            if(data.cityCodeList&&data.cityCodeList.length>0){
                let newList = [];
                data.cityCodeList.forEach(item=>newList.push(item.cityCode));
                data.cityCodeList = newList;
            }
            this.loading(true);
            const contactList =  this.onRefContactListChild.handleOK();
            data["contactList"] = contactList;
            const { id } = this.props;
            if(!isEmpty(id)){
                data["id"] = id;
            }
            LogisticsAction.addOrUpdate(data).then(res=>{
                const resData = res.data;
                this.loading(false);
                const { success, valid} = resData;
                if (success &&valid) {
                    // 保存成功
                    this.open(false)
                    if(this.props.refreshPage)this.props.refreshPage();// 刷新 页面数据
                }else if(resData.message){
                    message.warning(resData.message)
                }else {
                    message.warning(Lang({id:"BaoCunShiBai"}))
                }
            })
        }
    }
    // 完善表单
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefContactList = (ref) =>  this.onRefContactListChild = ref;
    init(){

    }
    componentDidMount(){

    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {loading, isModalVisible, detail} = this.state;
        const {id, children} = this.props;
        return (<Spin spinning={loading}>
                <span onClick={()=>this.open(true)}>{children}</span>
                {isModalVisible&&<EssaModal title={id?Lang({id:"BianJiWuLiuGongSi",default:"编辑物流公司"}):Lang({id:"XinZengWuLiuGongSi",default:"新增物流公司"})}
                                            open={isModalVisible}
                                            onCancel={()=>this.open(false)}
                                            maskClosable={false}
                                            onOk={()=>this.submit()}>
                            <Spin spinning={loading}>
                                <FormFormat onRef={this.onRefForm}
                                            options={[
                                                {
                                                    name:'name',
                                                    cnTitle:'物流公司名称',
                                                    cnTitleId:'WuLiuGongSiMingCheng',
                                                    required:true
                                                },{
                                                    name:'only',
                                                    type:'OnlyRender',
                                                    cnTitle:'联系人',
                                                    cnTitleId:'LianXiRen',
                                                    showTitle: true,
                                                    onlyRender: (<ContactList onRef={this.onRefContactList} list={detail.contactList}/>)
                                                },{
                                                    name:'remark',
                                                    cnTitle:'备注',
                                                    cnTitleId:'BeiZhu',
                                                    type:"TextArea",
                                                    minRows:2,
                                                },{
                                                    name:'cityCodeList',
                                                    type:"City",
                                                    cnTitle:'覆盖城市',
                                                    cnTitleId:'FuGaiChengShi',
                                                    required:true
                                                }
                                            ]}
                                            formLayout="vertical"
                                            initialValues={detail}  />
                            </Spin>
                </EssaModal>}
            </Spin>
        )
    }
}